export default __webpack_public_path__ + "static/media/Minicard_Tc.7d47be2d.svg";